import * as React from 'react'

// ---------------------------------------------------------------------------
// AspectRatio — CSS-only replacement for @radix-ui/react-aspect-ratio
// ---------------------------------------------------------------------------
// The native CSS `aspect-ratio` property is supported in all modern browsers.
// No primitive library required — this is a lightweight wrapper that preserves
// the same public API as the Radix version: `<AspectRatio ratio={16/9}>`.
// ---------------------------------------------------------------------------

export namespace AspectRatio {
  export interface Props extends React.ComponentProps<'div'> {
    /** Width-to-height ratio (e.g. 16/9, 4/3, 1). @default 1 */
    ratio?: number
  }
}

function AspectRatio({ ratio = 1, style, children, ...props }: AspectRatio.Props) {
  return (
    <div
      data-slot="aspect-ratio"
      style={{
        position: 'relative',
        width: '100%',
        aspectRatio: String(ratio),
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  )
}

export { AspectRatio }
